import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import ListItemsSelectNavigationContainer from "@/components/layouts/ListItemsSelectNavigationContainer/ListItemsSelectNavigationContainer.vue";
import { getSettingsTermsMenuItems } from "@/utils/settings";
import { useComputedValue } from "@/composables";
import { GetterTypes } from "@/store";
import { LocaleTypeEnum } from "@/types/localization";


export default /*#__PURE__*/_defineComponent({
  __name: 'SettingsTermsAndConditions',
  setup(__props) {

const locale = useComputedValue<LocaleTypeEnum>(GetterTypes.GET_LANGUAGE);
const menuItems = getSettingsTermsMenuItems(locale.value);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ListItemsSelectNavigationContainer, {
    "navigation-title": _ctx.$t('settings.termsAndConditions.title'),
    "lists-array": [_unref(menuItems)]
  }, null, 8, ["navigation-title", "lists-array"]))
}
}

})